var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useReducer, useRef } from 'react';
import axios from 'axios';
import { ApiPollService } from '../helpers/apiPollService';
/* eslint-disable import/prefer-default-export, @typescript-eslint/no-unused-vars, no-void, consistent-return */
export const useFetchApi = (url, delay, options) => {
    const cache = useRef({});
    const urlRef = useRef('');
    const busyRef = useRef(false);
    const apiPollService = new ApiPollService(delay || 4000);
    let cancelRequest = false;
    const initialState = {
        status: 'init',
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state = initialState, action) => {
        switch (action.type) {
            case 'FETCH_INIT':
                return Object.assign(Object.assign({}, state), { status: 'fetching', loading: true });
            case 'FETCH_SUCCESS':
                return Object.assign(Object.assign({}, state), { status: 'fetched', loading: false, data: action.payload });
            case 'FETCH_FAILURE':
                return Object.assign(Object.assign({}, state), { status: 'error', loading: false, error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(fetchReducer, initialState);
    useEffect(() => {
        // if URL is empty string
        // set it to a 'current' ref
        // unsubscribe previous and skip it to the next one
        if (urlRef.current !== url) {
            // unsubscribe previous
            apiPollService.removeCallBack(urlRef.current);
            // update ref
            urlRef.current = url || '';
        }
        if (!url)
            return;
        // Fetch once initial data with 'loading' state
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            busyRef.current = true;
            dispatch({ type: 'FETCH_INIT' });
            try {
                const response = yield axios(url, options).finally(() => {
                    busyRef.current = false;
                });
                if (cancelRequest)
                    return;
                dispatch({ type: 'FETCH_SUCCESS', payload: response.data });
            }
            catch (e) {
                if (cancelRequest)
                    return;
                dispatch({ type: 'FETCH_FAILURE', payload: e.message });
            }
        });
        // Fetch polling action: updates data silently
        const fetchPollApi = () => __awaiter(void 0, void 0, void 0, function* () {
            if (busyRef.current)
                return;
            busyRef.current = true;
            try {
                dispatch({ type: 'FETCH_INIT' });
                const response = yield axios(url, options).finally(() => {
                    busyRef.current = false;
                });
                if (cancelRequest)
                    return;
                dispatch({ type: 'FETCH_SUCCESS', payload: response.data });
            }
            catch (e) {
                if (cancelRequest)
                    return;
                dispatch({ type: 'FETCH_FAILURE', payload: e.message });
            }
        });
        // Pass on fetch data action to Poll Manager
        if (delay) {
            apiPollService.addCallback({
                url,
                action: fetchPollApi,
            });
        }
        // if (state.status !== 'fetching') {
        //   void fetchData();
        // }
        void fetchData();
        return () => {
            cancelRequest = true;
            apiPollService.clearAll();
        };
    }, [url]);
    return state;
};
